import { defineComponent as d, useSlots as l, useCssModule as p, createElementBlock as c, openBlock as r, normalizeClass as a, unref as e, createElementVNode as u, createCommentVNode as h, renderSlot as _ } from "vue";
import { _ as m } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const b = ["id", "role"], g = /* @__PURE__ */ d({
  name: "ll-page-content",
  __name: "PageContent",
  props: {
    activeTab: { default: void 0 }
  },
  setup(i) {
    const s = i, o = l(), t = p();
    return (n, T) => (r(), c("div", {
      id: s.activeTab ? `tabpanel-${s.activeTab}` : void 0,
      class: a(["stash-page-content", [
        e(t).root,
        {
          [e(t)["stash-page-content--has-sidebar"]]: !!e(o).sidebar
        }
      ]]),
      "data-test": "stash-page-content",
      role: s.activeTab ? "tabpanel" : void 0
    }, [
      u("div", {
        class: a(e(t)["stash-page-content__main"])
      }, [
        _(n.$slots, "default")
      ], 2),
      e(o).sidebar ? (r(), c("aside", {
        key: 0,
        class: a(e(t)["stash-page-content__sidebar"])
      }, [
        _(n.$slots, "sidebar")
      ], 2)) : h("", !0)
    ], 10, b));
  }
}), f = "_root_1fnu6_2", v = {
  root: f,
  "stash-page-content--has-sidebar": "_stash-page-content--has-sidebar_1fnu6_10",
  "stash-page-content__main": "_stash-page-content__main_1fnu6_16",
  "stash-page-content__sidebar": "_stash-page-content__sidebar_1fnu6_21"
}, C = {
  $style: v
}, y = /* @__PURE__ */ m(g, [["__cssModules", C]]);
export {
  y as default
};
//# sourceMappingURL=PageContent.js.map
